import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import Select from 'react-select'

const AutoMessageModal = props => {
  const [locations, setLocations] = useState([])
  const [selectedLocations, setSelectedLocations] = useState([])
  const [allLocationsSelected, setAllLocationsSelected] = useState(false)
  const [confirmedGames, setConfirmedGames] = useState(true)

  const { register, reset, setValue, handleSubmit  } = useForm({})

  useEffect(() => {
    if (!props.message) return

    reset(_.omit(props.message, 'id', 'created_at', 'updated_at'))
    setConfirmedGames(props.message.confirmed_games)

    if (props.message.locations[0] == 0) {
      setAllLocationsSelected(true)
    } else {
      handleLocationsSelect(props.locations.filter((l) => props.message.locations.includes(l.id)).map((location => {
        return { value: location.id, label: location.name }
      })))
    }
  }, [props.message])

  useEffect(() => {
    if (props.locations.length) {
      const allLocations = props.locations.map((location => {
        return { value: location.id, label: location.name }
      }))
      setLocations([...locations, ...allLocations])
    }
  }, [props.locations])

  const onSubmit = (data) => {
    props.message ? props.onUpdate({id: props.message.id, ...data}) : props.onCreate(data)
    props.onClose()
  }

  const handleLocationsSelect = values => {
    setSelectedLocations(values)
    setValue('locations', values.map(v => v.value))
  }

  return (
    <Modal container={document.body} show={true} onHide={props.onClose} dialogClassName='create-game-auto-messages'>
      <Modal.Header>
        <Modal.Title>{ props.message ? 'Edit Auto Message' : 'Create Auto Message' }</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='form-group'>
            <label className='control-label'>Locations</label>
            <label className='form-checkbox locations'>
              <input
                type='checkbox'
                defaultChecked={allLocationsSelected}
                name='allLocations'
                onClick={e => {
                  setAllLocationsSelected(e.target.checked)
                  setSelectedLocations([])
                  setValue('locations', [0])
                }} />
                For all locations
            </label>
            <Select
              multi
              searchable
              disabled={allLocationsSelected}
              closeOnSelect={false}
              removeSelected={false}
              allowSelectAll={true}
              value={selectedLocations}
              options={locations}
              {...register('locations')}
              onChange={ (values) => handleLocationsSelect(values) } />
          </div>
          <div className='form-group'>
            <label className='control-label'>Title</label>
            <input type='text' className='form-control' name='title' {...register('title')} />
          </div>
          <div className='form-group'>
            <label className='control-label'>Message</label>
            <textarea className='form-control' name='body' {...register('body')} />
          </div>
          <div className='form-group'>
            <label className='form-checkbox'>
              <input
                type='checkbox'
                defaultChecked={confirmedGames}
                onClick={e => {
                  setConfirmedGames(e.target.checked)
                  setValue('confirmed_games', e.target.checked)
                }}
                {...register('confirmed_games')} />
              Send when game is confirmed
            </label>
          </div>
          <div className='form-group form-footer'>
            <button className='btn btn-default' onClick={props.onClose}>Cancel</button>
            <input type='submit' className='btn btn-primary submit-btn' value='Save' />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default AutoMessageModal
